import {

  createContext,
  useContext,
  useEffect,
  useState

} from "react";

const AuthContext =
  createContext();

export const AuthProvider = ({
  children
}) => {

  const [user, setUser] =
    useState(null);

  const [token, setToken] =
    useState(null);

  const [loading, setLoading] =
    useState(true);

  // =====================================
  // 🔄 RESTORE SESSION
  // =====================================

  useEffect(() => {

    const restore =
      async () => {

        try {

          const storedToken =
            localStorage.getItem(
              "token"
            );

          if (!storedToken) {

            setLoading(false);

            return;
          }

          const res =
            await fetch(
              "https://ficon-x.com/auth/me",
              {

                headers: {

                  Authorization:
                    `Bearer ${storedToken}`
                }
              }
            );

          if (!res.ok) {

            throw new Error(
              "Session invalid"
            );
          }

          const me =
            await res.json();

          setUser(me);

          setToken(
            storedToken
          );

          console.log(
            "🔐 Session restored:",
            me
          );

        } catch (err) {

          console.error(
            "❌ Restore failed:",
            err
          );

          localStorage.removeItem(
            "token"
          );
        }

        setLoading(false);
      };

    restore();

  }, []);

  // =====================================
  // 🔑 LOGIN
  // =====================================

  const login =
    async (email, password) => {

      const res =
        await fetch(
          "https://ficon-x.com/auth/login",
          {

            method: "POST",

            headers: {
              "Content-Type":
                "application/json"
            },

            body: JSON.stringify({

              email,
              password
            })
          }
        );

      const data =
        await res.json();

      if (!res.ok) {

        throw new Error(
          data.error ||
          "Login failed"
        );
      }

      localStorage.setItem(
        "token",
        data.token
      );

      setToken(
        data.token
      );

      setUser(
        data.user
      );

      console.log(
        "✅ Logged in:",
        data.user
      );

      return data.user;
    };

  // =====================================
  // 🧾 REGISTER
  // =====================================

  const register =
    async (payload) => {

      const res =
        await fetch(
          "https://ficon-x.com/auth/register",
          {

            method: "POST",

            headers: {
              "Content-Type":
                "application/json"
            },

            body: JSON.stringify(
              payload
            )
          }
        );

      const data =
        await res.json();

      if (!res.ok) {

        throw new Error(
          data.error ||
          "Register failed"
        );
      }

      // 📧 New accounts must verify their email
      // before an authenticated session is created.
      console.log(
        "📧 Registration successful:",
        data
      );

      return data;
    };


  // =====================================
  // 🔄 REFRESH CURRENT USER PROFILE
  // =====================================

  const refreshUser =
    async () => {

      try {

        const storedToken =
          localStorage.getItem(
            "token"
          );

        if (!storedToken) {

          return null;
        }

        const res =
          await fetch(
            "https://ficon-x.com/auth/me",
            {

              headers: {

                Authorization:
                  `Bearer ${storedToken}`
              }
            }
          );

        if (!res.ok) {

          throw new Error(
            "Unable to refresh user profile"
          );
        }

        const me =
          await res.json();

        setUser(me);

        console.log(
          "🔄 User profile refreshed:",
          me
        );

        return me;

      } catch (err) {

        console.error(
          "❌ User profile refresh failed:",
          err
        );

        return null;
      }
    };
  // =====================================
  // 🚪 LOGOUT
  // =====================================

  const logout = () => {

    localStorage.removeItem(
      "token"
    );

    setUser(null);

    setToken(null);

    console.log(
      "🚪 Logged out"
    );
  };

  return (

    <AuthContext.Provider
      value={{

        user,

        token,

        loading,

        login,

        register,

        refreshUser,

        logout
      }}
    >

      {children}

    </AuthContext.Provider>
  );
};

export const useAuth = () =>
  useContext(AuthContext);